import { BaseAPIModel } from '@weezevent/weezjs-core';
import { aliases } from '../i18n/i18n';

export default class Organization extends BaseAPIModel {
    fields() {
        return {
            name: {},
            id: { primaryKey: true, readOnly: true }
        };
    }

    defaultLanguage() {
        const orgaLocale = this.default_locale?.replace('_', '-') || 'en-GB';
        const locale = aliases[orgaLocale] ?? orgaLocale;
        return locale;
    }

    has_feature(key) {
        return this.feature_flags && this.feature_flags.include(key);
    }

    static listUrl() {
        return `/ticket/organizations`;
    }

    resend_bank_mail() {
        let url = `${this.constructor.listUrl({})}/${this.id}/send_bank_confirm`;
        return BaseAPIModel.fetcher.post(url, {});
    }
}
